var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_of_Twitter 1",
    clipPath: "url(#clip0_1_141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2144 3.51992C15.2247 3.66885 15.2247 3.81777 15.2247 3.96806C15.2247 8.54757 11.7424 13.8291 5.37493 13.8291V13.8264C3.49397 13.8291 1.65207 13.2897 0.0686035 12.2727C0.342112 12.3056 0.616991 12.3221 0.892555 12.3228C2.45135 12.3241 3.96558 11.8005 5.19191 10.8363C3.71058 10.8082 2.41159 9.8412 1.9578 8.42953C2.47671 8.52973 3.01139 8.50914 3.5207 8.36983C1.9057 8.04316 0.743805 6.62257 0.743805 4.97277V4.92885C1.22501 5.19718 1.76381 5.3461 2.31493 5.36257C0.793845 4.34483 0.324974 2.31894 1.24352 0.735022C3.0011 2.90022 5.59429 4.21649 8.37804 4.35581C8.09905 3.15208 8.48018 1.89071 9.37953 1.04453C10.7738 -0.267625 12.9667 -0.20037 14.2773 1.19483C15.0526 1.04179 15.7957 0.756983 16.4757 0.353454C16.2172 1.15571 15.6764 1.83718 14.9539 2.27022C15.6401 2.18924 16.3105 2.00532 16.9418 1.72463C16.477 2.42189 15.8916 3.02924 15.2144 3.51992Z",
    fill: "#1D9BF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.c23e0cd07075f75811b4b9cc4008019a.svg";
export { ForwardRef as ReactComponent };